import {useEffect, useState} from 'react';

import {config} from '../config';
import {toClientCallType} from '../utils/toClientCallTypes';
import {getIsMeetingManagerPath} from '../utils/getIsMeetingManagerPath';
import {router} from '../router';

export const useMeetingManagerConfig = () => {
    const [path, setPath] = useState(location.pathname);
    useEffect(() => {
        const isMeetingManagerPath = getIsMeetingManagerPath(path);
        if (isMeetingManagerPath) {
            config.set({key: 'callType', value: toClientCallType('none')});
            config.set({key: 'join', value: true});
        }
        return router.urlChangedSignal.add(() => {
            setPath(location.pathname);
        });
    }, [path]);
};
